import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {Sprite} from "../core/Sprite";

export class OnboardingArrow extends Container {

    private readonly sprite = this.addChild(new Sprite("onboarding-arrow", {x: 0.1, y: 0.5}));

    constructor() {
        super();

        this.sprite.tweenTo(0.4, Ease.sineInOut, {
            x: -this.sprite.width * 0.2,
            repeat: -1,
            yoyo: true,
        });
    }

    public show() {
        this.scaleFrom(0, 0.4, Ease.sineOut);
    }

    public hide() {
        this.scaleTo(0, 0.2, Ease.sineIn, () => {
            this.destroy();
        });
    }
}
